module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.changePassword($event)
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block form form-horizontal"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3",
    class: {
      'has-danger': _vm.$v.model.senha.$error
    }
  }, [_c('dw-ipassword', {
    ref: "senha",
    staticClass: "mb-1",
    class: {
      'has-danger': _vm.$v.model.senha.$error
    },
    attrs: {
      "slot": "input",
      "placeholder": "Senha",
      "length": 6,
      "maxlength": 30,
      "helper": true
    },
    on: {
      "input": function($event) {
        _vm.$v.model.senha.$touch()
      }
    },
    slot: "input",
    model: {
      value: (_vm.model.senha),
      callback: function($$v) {
        _vm.$set(_vm.model, "senha", $$v)
      },
      expression: "model.senha"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3",
    class: {
      'has-danger': _vm.$v.model.repetirSenha.$error
    }
  }, [_c('dw-ipassword', {
    ref: "repetirSenha",
    staticClass: "mb-4",
    class: {
      'has-danger': _vm.$v.model.repetirSenha.$error
    },
    attrs: {
      "slot": "input",
      "placeholder": "Repetir Senha",
      "length": 6,
      "maxlength": 30,
      "helper": false
    },
    on: {
      "input": function($event) {
        _vm.$v.model.repetirSenha.$touch()
      }
    },
    slot: "input",
    model: {
      value: (_vm.model.repetirSenha),
      callback: function($$v) {
        _vm.$set(_vm.model, "repetirSenha", $$v)
      },
      expression: "model.repetirSenha"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-footer text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-link",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Salvar")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-key"
  }), _vm._v(" Alterar Senha\n                    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f82bbd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/ChangePassword.vue
// module id = 884
// module chunks = 1